import { useQuery } from '@tanstack/react-query';

export function useVehiclesQuery(api, orgId, authToken) {
  return useQuery({
    queryKey: ['vehicles', orgId],
    queryFn: () => api.vehicles.getAll(orgId, authToken),
    enabled: Boolean(api && orgId && authToken),
  });
}
